import clsx from 'clsx';
import { useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { Button } from 'components/rebrand/Button';
import { LocaleContext } from 'components/rebrand/Layout';

import { trackEventUniversal } from 'helpers';

const CTA_BudgetTemplate = ({ className }: { className?: string }) => {
  const locale = useContext(LocaleContext);

  return (
    <div
      className={twMerge(
        clsx('text-grey-450 bg-primary-50 mb-64 flex flex-col items-start overflow-hidden rounded-16 p-32', className),
      )}
    >
      <h3 className="pb-8 text-left text-xl font-bold text-primary-400">
        {
          {
            en: `Get your personal budget template!`,
            fr: `Téléchargez votre modèle de budget personnel!`,
          }[locale]
        }
      </h3>
      <p className="text-md">
        {
          {
            en: `See where your money is going and how much you can save.`,
            fr: `Voyez où va votre argent et combien vous pouvez épargner.`,
          }[locale]
        }
      </p>
      <a
        download={{ en: 'personal-budget-template-en.xlsx', fr: 'personal-budget-template-fr.xlsx' }[locale]}
        onClick={() =>
          trackEventUniversal('Personal Budget Template Clicked', {
            event_category: 'tracking',
            event_label: 'budget-template',
          })
        }
        href={
          {
            en: '/personal-budget-template-en.xlsx',
            fr: '/personal-budget-template-fr.xlsx',
          }[locale]
        }
      >
        <Button>{{ en: `Get it now`, fr: `Télécharger` }[locale]}</Button>
      </a>
    </div>
  );
};

export default CTA_BudgetTemplate;
